import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Redirect } from "react-router-dom";
import { restoreSession, getKillSwitchInfo } from "../../store/session";
import SplashScreen from "../SplashScreen";
import ATCO from "../ATCO";
import Login from "../Login";
import Maintenance from "../Maintenance";
import Driver from "../Driver";
import ErrorPage from "../ErrorPage";
import {getUrlParameter} from '../../configs/utils';
import { usePrevious } from "../../hooks/usePrevious";
import {
  getSessionInfo
} from "../../store/session";
import constants from "../../configs/constants";
import { wsConnect, wsDisconnect, wsSend } from "../../store/pushback";
const { connect } = require("react-redux");

const Home = props => {
  const restoring = useSelector(state => state.session.restoring);
  const switchDataMessage = useSelector(state => state.session.switchDataMessage);
  // const switchData = useSelector((state) => state.pushback.switchData);

  const wsOpened = useSelector((state) => state.pushback.wsOpened);
  const gatesData = useSelector((state) => state.pushback.gatesData);

  const user = useSelector(state => state.session.user);
  const dispatch = useDispatch();
  const [sessionID, setSessionID] = useState();
  const [toggleSwitch, setToggleSwitch] = useState(false);

  const [refetch, setRefetch] = useState(false);
  const [userLocal, setUserLocal] = useState(
    JSON.parse(localStorage.getItem("driverToken"))
  );
  const [switchData, setSwitchData] = useState(
    localStorage.getItem("switchStatus")
  );
  const prevWSOpened = usePrevious(wsOpened);

  //added this for refresh token
  const getToken = window.localStorage.getItem("accessToken");

  useEffect(() => {
    if (switchData === 'ON') {
      setTimeout(() => {
        dispatch(getKillSwitchInfo({message: 'getS3Message'}));
        reloadPage();
      }, 30000);
      console.log('reload pagee')
    } else {
      console.log('switchData main dont do anything')
    }
    
  }, [switchData]);

  useEffect(() => {
    
    const session_id = getUrlParameter(window.location.href, 'session_id')
    console.log(window.location.href, session_id);

    if (session_id) {
      setSessionID(session_id);
      let param = {
        session_id  
      };
      props.getSessionInfo(param);

    }
  }, []);


  

  // useEffect(() => {
  //   if (switchData) {
  //     console.log('switchData home', switchData);
  //     if (switchData[0].status === 'ON') {
  //       setToggleSwitch(true);
  //     } else {
  //       setToggleSwitch(false)
  //     }
  //   }
  // }, [switchData]);

  // useEffect(() => {
  //   if (window.localStorage.getItem("switchStatus")) {
  //     console.log('switchData home', switchData);
  //     if (window.localStorage.getItem("switchStatus") === 'ON') {
  //       setToggleSwitch(true);
  //     } else {
  //       setToggleSwitch(false)
  //     }
  //   }
  // }, [switchData]);

  useEffect(() => {
    if (getToken) {
      checkAccessToken();
    }
  }, [user]);
  
  useEffect(() => {
    if (toggleSwitch) {
      console.log('switchData toggle', toggleSwitch)
    } else {
      console.log('switchData toggle 2', toggleSwitch)
    }
  }, [toggleSwitch]);

  useEffect(() => {
    dispatch(
      getKillSwitchInfo({message: 'getS3Message'})
    )
    dispatch(restoreSession());
  }, [dispatch]);

  useEffect(() => {
    const getSwitch = window.localStorage.getItem("switchStatus");
      setSwitchData(getSwitch)
  }, [switchDataMessage]);

  useEffect(() => {
    if (switchData && switchDataMessage) {
      console.log('switchData home', switchData);
      if (switchData === 'ON') {
        setToggleSwitch(true);
      } else {
        setToggleSwitch(false)
      }
    }
  }, [switchData, switchDataMessage]);

   // on load from local storage
  //  useEffect(() => {
  //   // console.log("DRIVER SECOND");
  //   if (userLocal) {
  //     console.log("RESTORE SESSION");
  //     dispatch(restoreSession());

  //     //once user successfully logged in connect with web socket
  //     const getToken = window.localStorage.getItem("driverAccessToken");
  //     let websocketURL = constants.SOCKET_ROOT_URL + getToken;

  //     console.log('dispatchhhing hereee')

  //     dispatch(wsConnect(websocketURL));
  //     // dispatch(updateUser(userLocal));

  //     //store the userlocal from the local storage to the user store
  //   }
  // }, []);

  // useEffect(() => {
  //   // console.log("DRIVER THIRD");
  //   console.log("wsOpened 2", wsOpened);
  //   if (!prevWSOpened && wsOpened) {
  //     dispatch(wsSend({ action: constants.ACTION_ON_GET_S3_MESSAGE }));
  //     setInterval(() => {
  //       console.log("Heartbeat: fetch gates data ");
  //       dispatch(wsSend({ action: constants.ACTION_ON_GET_S3_MESSAGE }));
  //     }, constants.HEARTBEAT_INTERVAL);

  //     setInterval(() => {
  //       console.log("Triggering Re fetch");
  //       setRefetch(Math.random());
  //     }, 60000);

  //   }
  // }, [wsOpened]);

  const reloadPage = () => {
    window.location.reload();
  };


  const checkAccessToken = () => {
    if (user && !toggleSwitch) {
      if (user.accessToken.payload["cognito:groups"] && user.accessToken.payload["cognito:groups"][0] == "atco") {
        // alert('ACCESS TOKEN SAME');
        return <Redirect to='/atco' />
      } else {
        // alert('ACCESS TOKEN NOT THE SAME');
        return <Redirect to='/driver' />;
      }
    } else if (user && toggleSwitch) {
      console.log('switchData home 2', switchData);
      return <Maintenance />;
    } else if (!user && toggleSwitch) {
      console.log('switchData home 3 2', switchData);
      return <Maintenance />;
    } else if (!user && !toggleSwitch) {
      // alert('USER IS NULL');
      console.log("USER IS NULL");
      return <Login />;
    }

  }

  if (restoring == true) {
    return <SplashScreen />;
  }
  if (user && !toggleSwitch) {
    return user.accessToken.payload["cognito:groups"] && user.accessToken.payload["cognito:groups"][0] == "atco" ? (
      // <ATCO />
      <Redirect to='/atco' />
    ) : (
        // <Driver />
        <Redirect to='/driver' />
      );
  }
  if (sessionID && !props.sessionInfo) {
    return <SplashScreen />;
  }
  if (switchData && toggleSwitch) {
    console.log('switchData home 3', switchData);
    return <Maintenance />;
  }
  if(props.sessionInfo && props.sessionInfo.status==='error'){
    return <ErrorPage />
  }
  if (switchData && !toggleSwitch) {
    console.log('switchData login 3', switchData);
    return <Login />;
  }
  if (!switchData && !toggleSwitch) {
    console.log('switchData login 4', switchData);
    return <Login />;
  }
  // return <Login />;
};

const mapStateToProps = state => ({
  loading: state.session.loading,
  error: state.session.error,
  sessionInfo: state.session.sessionInfo,
  switchDataMessage: state.session.switchDataMessage,
});

const mapDispatchToProps = {
  getSessionInfo
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
